export default "__VITE_ASSET__Blr9p2SY__"